import axiosRequest from "@/utils/axios-utils";
import { decodeJwt } from "@/utils/global";

export const loginByEmailOrMobile = async ({ value, recaptchaToken }) => {
  const isEmail = value.includes("@");
  const data = JSON.stringify({
    mobilenumber: isEmail ? "" : "966".concat(value.slice(-9)),
    otptype: "login",
    email: isEmail ? value : "",
    resendotp: "",
    oldmobile: "",
  });
  const config = {
    method: "post",
    url: "/customer/v2/otpSend",
    headers: {
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: "Bearer next",
    },
    data,
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const fetchHandshake = async ({ token, locale }) => {
  if (
    token &&
    locale == decodeJwt(token)?.store &&
    decodeJwt(token)?.exp > Date.now()
  ) {
    return token;
  } else {
    const response = await axiosRequest({
      method: "POST",
      url: "/handshake",
      data: { store: locale },
    });

    return response.data.token;
  }
};

export const verifyOTPByEmail = async ({
  token,
  useremailphone,
  otpcode,
  locale,
  recaptchaToken,
}) => {
  const handshake = await fetchHandshake({ token, locale });

  const isEmail = useremailphone.includes("@");
  const data = JSON.stringify({
    mobilenumber: isEmail ? "" : "966".concat(useremailphone.slice(1)),
    email: isEmail ? useremailphone : "",
    otpcode,
    otptype: "login",
    oldmobile: "",
  });
  const config = {
    method: "post",
    url: "/customer/v2/otpVerfiy",
    headers: {
      Authorization: `Bearer ${handshake}`,
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: "Bearer next",
    },
    data,
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};
